import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.js';

export interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  /** Breadcrumb or back-link slot, rendered above the title. */
  eyebrow?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, action, eyebrow, className }: PageHeaderProps) {
  return (
    <div className={cn('mb-8', className)}>
      {eyebrow ? <div className="mb-2">{eyebrow}</div> : null}
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-bold tracking-tight">{title}</h1>
          {description ? <p className="mt-1.5 text-sm text-text-muted">{description}</p> : null}
        </div>
        {action}
      </div>
    </div>
  );
}
